import { useKeycloak } from "@react-keycloak/web";
import { useState, useRef, useEffect } from 'react';
import { IoLogOutOutline } from 'react-icons/io5';
import { IoCreateOutline } from 'react-icons/io5';
import { Avatar } from './Avatar';
import { getBadgeTailwindClasses } from '../styles/designSystem';
import { Link } from 'react-router-dom';
import { useCurrentUser, useCurrentUserStore } from '../state/currentUser';

export const UserInfo = () => {
  const { keycloak } = useKeycloak();
  const { profile } = useCurrentUser();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    useCurrentUserStore.getState().clear();
    keycloak.logout({ redirectUri: window.location.origin });
  };

  // Keycloak's mini-profile claims (given_name/family_name/email) were removed
  // for containing personal data - identity now comes from the profile API.
  const firstName = profile?.first_name || '';
  const lastName = profile?.last_name || '';
  const email = profile?.email || '';
  const fullName = `${firstName} ${lastName}`.trim() || 'User';

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="h-9 w-9 rounded-lg bg-white border border-[#eaeaea] cursor-pointer transition-all duration-150 hover:bg-[#fafafa] hover:border-[#ddd] flex items-center justify-center"
      >
        <Avatar
          firstName={firstName}
          lastName={lastName}
          email={email}
          src={profile?.photo_url}
          size={32}
        />
      </button>

      {isOpen && (
        <div className="absolute -right-[16px] mt-1.5 w-[260px] bg-white rounded-xl border border-[#eaeaea] shadow-[0_4px_12px_rgba(0,0,0,0.08)] py-1 z-50" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif' }}>
                      <div className="px-3 py-1.5 text-[11px] text-[#888] uppercase tracking-wider font-medium">Profile <span className={getBadgeTailwindClasses('dev')}>dev</span></div>
          
          <div className="px-3 py-2">
            <div className="flex items-center gap-3">
              <Avatar
                firstName={firstName}
                lastName={lastName}
                email={email}
                src={profile?.photo_url}
                size={36}
              />
              <div>
                <div className="text-[13px] text-[#171717] font-medium">{fullName}</div>
                <div className="text-[12px] text-[#888]">{email}</div>
              </div>
            </div>
          </div>

          <div className="border-t border-[#eaeaea] mt-1">
            <Link
              to="/profile"
              onClick={() => setIsOpen(false)}
              className="w-full px-3 py-1.5 text-left hover:bg-[#fafafa] flex items-center gap-2.5 text-[13px] text-[#666] hover:text-[#171717] transition-colors duration-100"
            >
              <IoCreateOutline className="text-[#888] w-3.5 h-3.5" />
              View Profile
            </Link>
            <button
              onClick={handleLogout}
              className="w-full px-3 py-1.5 text-left hover:bg-[#fafafa] flex items-center gap-2.5 text-[13px] text-[#666] hover:text-[#171717] transition-colors duration-100"
            >
              <IoLogOutOutline className="text-[#888] w-3.5 h-3.5" />
              Log out
            </button>
          </div>
        </div>
      )}
    </div>
  );
};